export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7191.1a1a57dd.jpg";